export default __webpack_public_path__ + "static/media/congratulations-footer.ab40b556.png";